<div class="notification-container">
  <div class="notification-content">
    <div
      class="upcoming-match-section"
      *ngIf="isLoading || upcomingReservations.length"
    >
      <div class="section-card match-card">
        <div class="loading-container" *ngIf="isLoading">
          <div class="loading-spinner"></div>
          <div class="loading-content">
            <h3 class="loading-title">Loading Your Matches...</h3>
            <p class="loading-text">Fetching your upcoming padel matches</p>
          </div>
        </div>

        <div
          class="match-content"
          *ngIf="!isLoading && upcomingReservations.length"
        >
          <div class="match-header">
            <div class="time-indicator">
              <span class="time-icon"
                ><lucide-icon name="clock" [size]="18"></lucide-icon
              ></span>
              <h3 class="time-text">{{ getUpcomingMatchTimeString() }}</h3>
            </div>

            <div
              class="match-navigation"
              *ngIf="upcomingReservations.length > 1"
            >
              <button
                class="nav-button"
                (click)="prevReservation()"
                [disabled]="upcomingReservations.length <= 1"
                aria-label="Previous match"
              >
                <span class="nav-icon">‹</span>
              </button>
              <span class="match-counter"
                >{{ reservationIndex + 1 }} /
                {{ upcomingReservations.length }}</span
              >
              <button
                class="nav-button"
                (click)="nextReservation()"
                [disabled]="upcomingReservations.length <= 1"
                aria-label="Next match"
              >
                <span class="nav-icon">›</span>
              </button>
            </div>
          </div>

          <div class="match-details">
            <div class="custom-detail-container">
              <div class="custom-row">
                <div class="custom-detail-card">
                  <div class="custom-icon">
                    <lucide-icon name="calendar" [size]="18"></lucide-icon>
                  </div>
                  <div class="custom-info">
                    <div class="custom-label">DATE</div>
                    <div class="custom-value">{{ getUpcomingMatchDate() }}</div>
                  </div>
                </div>

                <div class="custom-detail-card">
                  <div class="custom-icon">
                    <lucide-icon name="clock" [size]="18"></lucide-icon>
                  </div>
                  <div class="custom-info">
                    <div class="custom-label">TIME</div>
                    <div class="custom-value">{{ getUpcomingMatchTime() }}</div>
                  </div>
                </div>
              </div>

              <div class="custom-row">
                <div class="custom-detail-card">
                  <div class="custom-icon">
                    <lucide-icon name="landmark" [size]="18"></lucide-icon>
                  </div>
                  <div class="custom-info">
                    <div class="custom-label">CLUB</div>
                    <div class="custom-value">{{ getClubName() }}</div>
                  </div>
                </div>

                <div class="custom-detail-card">
                  <div class="custom-icon">
                    <lucide-icon name="circle-dot" [size]="18"></lucide-icon>
                  </div>
                  <div class="custom-info">
                    <div class="custom-label">COURT</div>
                    <div class="custom-value">
                      {{ getUpcomingMatchCourt() }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="custom-row">
                <div class="custom-detail-card">
                  <div class="custom-icon">
                    <lucide-icon name="lock" [size]="18"></lucide-icon>
                  </div>
                  <div class="custom-info">
                    <div class="custom-label">TYPE</div>
                    <div class="custom-value">
                      {{ upcomingMatch?.is_private ? "Private" : "Public" }}
                    </div>
                  </div>
                </div>

                <div class="custom-detail-card">
                  <div class="custom-icon">
                    <lucide-icon name="bar-chart-3" [size]="18"></lucide-icon>
                  </div>
                  <div class="custom-info">
                    <div class="custom-label">STATUS</div>
                    <div class="custom-value" [ngClass]="getStatusClass()">
                      {{ upcomingMatch?.reservation_status || "Pending" }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="players-section">
              <h4 class="players-title">Match Players</h4>

              <div
                class="teams-container"
                *ngIf="
                  upcomingMatch?.courtReservationPlayer?.length == 4;
                  else singleMatch
                "
              >
                <div class="team">
                  <div class="team-header">Team 1</div>
                  <div class="player-list">
                    <div class="player-item">
                      <span class="player-number">1</span>
                      <span class="player-name">{{
                        playerName(0) || "TBD"
                      }}</span>
                    </div>
                    <div class="player-item">
                      <span class="player-number">2</span>
                      <span class="player-name">{{
                        playerName(1) || "TBD"
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="vs-divider">VS</div>

                <div class="team">
                  <div class="team-header">Team 2</div>
                  <div class="player-list">
                    <div class="player-item">
                      <span class="player-number">1</span>
                      <span class="player-name">{{
                        playerName(2) || "TBD"
                      }}</span>
                    </div>
                    <div class="player-item">
                      <span class="player-number">2</span>
                      <span class="player-name">{{
                        playerName(3) || "TBD"
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <ng-template #singleMatch>
                <div class="single-match-container">
                  <div class="single-player">
                    <div class="single-player-card">
                      <span class="single-player-number">1</span>
                      <span class="single-player-name">{{
                        playerName(0) || "You"
                      }}</span>
                    </div>
                  </div>

                  <div class="single-vs-divider">VS</div>

                  <div class="single-player">
                    <div class="single-player-card">
                      <span class="single-player-number">2</span>
                      <span class="single-player-name">{{
                        playerName(1) || "TBD"
                      }}</span>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>

            <div class="custom-actions-container">
              <button
                *ngIf="upcomingMatch && canManagePlayers(upcomingMatch)"
                class="custom-action-btn custom-manage-btn"
                (click)="openPlayerDialog()"
              >
                <span class="custom-btn-icon"
                  ><lucide-icon name="users" [size]="16"></lucide-icon
                ></span>
                <span class="custom-btn-text">Manage Players</span>
              </button>

              <button
                *ngIf="upcomingMatch && canCancel(upcomingMatch)"
                class="custom-action-btn custom-cancel-btn"
                (click)="confirmCancelReservation()"
              >
                <span class="custom-btn-icon"
                  ><lucide-icon name="x" [size]="16"></lucide-icon
                ></span>
                <span class="custom-btn-text">Cancel Match</span>
              </button>
            </div>
          </div>

          <div class="match-status-action">
            <ng-container
              [ngSwitch]="upcomingMatch?.reservation_status || 'Pending'"
            >
              <div *ngSwitchCase="'Pending'" class="status-badge pending">
                <span class="status-icon"
                  ><lucide-icon name="loader-2" [size]="16"></lucide-icon
                ></span>
                <span class="status-text">Pending Approval</span>
              </div>
              <div *ngSwitchCase="'Denied'" class="status-badge denied">
                <span class="status-icon"
                  ><lucide-icon name="circle-x" [size]="16"></lucide-icon
                ></span>
                <span class="status-text">Match Denied</span>
              </div>
              <div *ngSwitchDefault>
                <button
                  *ngIf="!upcomingMatch?.started"
                  class="start-match-button"
                  (click)="startMatch()"
                >
                  <span class="button-icon"
                    ><lucide-icon name="circle-dot" [size]="16"></lucide-icon
                  ></span>
                  <span class="button-text">Start Match</span>
                </button>
                <button
                  *ngIf="
                    upcomingMatch?.started &&
                    !upcomingMatch?.finished &&
                    !upcomingMatch?.admin_approve_start
                  "
                  class="continue-match-button"
                  (click)="goToYourMatch()"
                >
                  <span class="button-icon">▶️</span>
                  <span class="button-text">Continue Match</span>
                </button>
                <button
                  *ngIf="
                    upcomingMatch?.started &&
                    !upcomingMatch?.finished &&
                    upcomingMatch?.admin_approve_start
                  "
                  class="end-match-button"
                  (click)="goToYourMatch()"
                >
                  <span class="button-icon"
                    ><lucide-icon name="check" [size]="16"></lucide-icon
                  ></span>
                  <span class="button-text">End Match</span>
                </button>
                <div
                  *ngIf="upcomingMatch?.finished"
                  class="status-badge finished"
                >
                  <span class="status-icon"
                    ><lucide-icon name="circle-check" [size]="16"></lucide-icon
                  ></span>
                  <span class="status-text">Match Finished</span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div
      class="quick-actions-section"
      [class.centered]="!upcomingReservations.length"
    >
      <h3 class="section-title">Quick Actions</h3>
      <div class="actions-grid">
        <button class="action-card" (click)="goToRbRank()">
          <div class="card-icon">
            <img src="../../assets/images/analytics.png" alt="RB Rank" />
          </div>
          <div class="card-content">
            <h4 class="card-title">RB Rank</h4>
            <p class="card-description">View rankings</p>
          </div>
          <div class="card-arrow">›</div>
        </button>

        <button class="action-card" (click)="goToMatchHistory()">
          <div class="card-icon">
            <img
              src="../../assets/images/match-history-icon.png"
              alt="Match History"
            />
          </div>
          <div class="card-content">
            <h4 class="card-title">Match History</h4>
            <p class="card-description">Past matches</p>
          </div>
          <div class="card-arrow">›</div>
        </button>

        <button class="action-card" (click)="goToFriendships()">
          <div class="card-icon">
            <img
              src="../../assets/images/friendship-icon.png"
              alt="Friendships"
            />
          </div>
          <div class="card-content">
            <h4 class="card-title">Friendships</h4>
            <p class="card-description">Manage friends</p>
          </div>
          <div class="card-arrow">›</div>
        </button>

        <button class="action-card" (click)="goToClubMembership()">
          <div class="card-icon">
            <img
              src="../../assets/images/club-membership-icon.png"
              alt="Club Membership"
            />
          </div>
          <div class="card-content">
            <h4 class="card-title">Club Membership</h4>
            <p class="card-description">Your clubs</p>
          </div>
          <div class="card-arrow">›</div>
        </button>
      </div>
    </div>

    <app-scoring-rules></app-scoring-rules>
  </div>
</div>
<div
  class="custom-modal-overlay"
  *ngIf="playerDialogVisible"
  (click)="closePlayerDialog()"
>
  <div class="custom-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Manage Players</h2>
      <button class="modal-close" (click)="closePlayerDialog()">
        <span class="close-icon">✕</span>
      </button>
    </div>

    <div class="modal-content" *ngIf="selectedReservation">
      <div class="players-list">
        <div
          *ngFor="let p of selectedReservation.courtReservationPlayer"
          class="player-item"
        >
          <span class="player-name">{{ p.player?.full_name }}</span>
          <button
            *ngIf="p.player_id !== selectedReservation.user_id"
            class="remove-player-btn"
            (click)="removePlayer(p.player_id)"
          >
            <span class="remove-icon">✕</span>
          </button>
        </div>
      </div>

      <div class="add-player-section">
        <div class="search-wrapper">
          <input
            type="text"
            class="player-search"
            placeholder="Search player..."
            [(ngModel)]="searchQuery"
            (input)="onSearchInput($event)"
          />
          <div class="search-icon">
            <lucide-icon name="search" [size]="16"></lucide-icon>
          </div>
        </div>

        <div class="suggestions-list" *ngIf="playerSuggestions.length">
          <div
            *ngFor="let suggestion of playerSuggestions"
            class="suggestion-item"
            (click)="selectPlayer(suggestion)"
          >
            {{ suggestion.label }}
          </div>
        </div>

        <button
          class="add-player-btn"
          [disabled]="!newPlayer"
          (click)="addPlayer()"
        >
          <span class="add-icon">+</span>
          <span class="add-text">Add Player</span>
        </button>
      </div>
    </div>
  </div>
</div>
